var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("vue-good-table", {
        ref: "table",
        attrs: {
          columns: _vm.columns,
          rows: _vm.data,
          "pagination-options": {
            enabled: true,
            nextLabel: _vm.$t("txtNext"),
            prevLabel: _vm.$t("txtPrev"),
            rowsPerPageLabel: _vm.$t("txtPagePer"),
            ofLabel: _vm.$t("txtOf"),
            pageLabel: _vm.$t("txtPage"),
            allLabel: _vm.$t("txtAll")
          },
          "select-options": _vm.selectConfig,
          "search-options": { enabled: true, placeholder: _vm.$t("txtSearch") }
        },
        on: { "on-row-click": _vm.onClick }
      }),
      _vm._v(" "),
      _c("edit-modal", {
        ref: "modal",
        attrs: { modalId: "editmodal" + _vm.type, data: _vm.editData },
        on: { save: _vm.save }
      }),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-success my-2 float-right",
          attrs: {
            type: "button",
            "data-target": "#editmodal" + _vm.type,
            "data-toggle": "modal"
          },
          on: { click: _vm.initNew }
        },
        [_vm._v(_vm._s(_vm.$t("btnAdd")))]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }